<template>
  <div
    v-cloak
    v-if="template && rules"
    class="item-common pt-10 pb-15 px-7 type-career"
  >
    <div class="header">
      <div class="d-flex">
        <h1 class="title">
          {{ $t('학내외활동') }}
          <span
            v-if="itemMaxLength && $i18n.locale == 'ko'"
            class="max-length-guide"
          >
            최대 {{ itemMaxLength }}개 입력 가능</span
          >
          <span
            v-if="itemMaxLength && $i18n.locale == 'en'"
            class="max-length-guide"
          >
            You can enter Max {{ itemMaxLength }}</span
          >
        </h1>
      </div>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideSchoolActivity"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <div class="mt-8" v-if="obj">
          <v-row class="mt-2">
            <v-col
              cols="12"
              :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
            >
              <v-row>
                <v-col cols="12" class="col-md-2" :class="colclass">
                  <i-select
                    :label="itemLabel('schoolactType')"
                    :items="itemArray('schoolactType')"
                    v-model="obj.schoolactType"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[rules.required('schoolactType', true)]"
                    :class="leftRoundedClass"
                  ></i-select>
                </v-col>
                <v-col cols="12" class="col-md-4" :class="colclass">
                  <i-text-field
                    v-model="obj.schoolactOrganization"
                    v-maxlength="'schoolactOrganization'"
                    :label="itemLabel('schoolactOrganization')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('schoolactOrganization', true),
                      rules.maxlength('schoolactOrganization'),
                    ]"
                    :class="leftRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('schoolactSdate')"
                    useMaxCurrentDate
                    :rules="[rules.required('schoolactSdate', true)]"
                    v-model="obj.startDate"
                    :type="
                      schoolactSdateFormat === 'YYYY.MM' ? 'month' : 'date'
                    "
                  />
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('schoolactEdate')"
                    :min="obj.startDate"
                    useMaxCurrentDate
                    :disabled="obj.isEmployed == 'Y'"
                    :rules="[rules.required('schoolactEdate', true)]"
                    v-model="obj.endDate"
                    :type="
                      schoolactEdateFormat === 'YYYY.MM' ? 'month' : 'date'
                    "
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1">
              <i-btn elevation="0" color="primary" block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
          <template v-if="schoolActivity === 'B' || schoolActivity === 'C'">
            <v-row :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-text-field
                  :label="itemLabel('schoolactPosition')"
                  v-model="obj.schoolactPosition"
                  v-maxlength="'schoolactPosition'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolactPosition', true),
                    rules.maxlength('schoolactPosition'),
                  ]"
                ></i-text-field>
              </v-col>
            </v-row>
          </template>
          <v-row :class="rowclass">
            <v-col cols="12" :class="colclass">
              <i-textarea
                outlined
                :label="itemLabel('schoolactDescription')"
                v-model="obj.schoolactDescription"
                dense
                hide-details="auto"
                :rules="[
                  rules.required('schoolactDescription', true),
                  rules.maxlength('schoolactDescription'),
                ]"
                :disabled="itemLength('schoolactDescription') == 0"
                :readonly="isReadonly"
                :counter="itemLength('schoolactDescription')"
              ></i-textarea>
            </v-col>
          </v-row>
          <template v-if="schoolActivity === 'C'">
            <v-row :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-text-field
                  :label="itemLabel('schoolactNote')"
                  v-model="obj.schoolactNote"
                  v-maxlength="'schoolactNote'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolactNote', true),
                    rules.maxlength('schoolactNote'),
                  ]"
                ></i-text-field>
              </v-col>
            </v-row>
          </template>
          <v-row class="mt-2">
            <v-col cols="12" class="d-md-none d-block">
              <i-btn elevation="0" color="normal" outlined block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm" :readonly="isReadonly">
        <template v-for="(item, i) in schoolActivities">
          <v-divider :key="'schoolActivitydiv' + i" v-if="i != 0"></v-divider>
          <div class="mt-8" v-if="item" :key="'schoolActivity' + i">
            <v-row class="mt-2">
              <v-col
                cols="12"
                :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
              >
                <v-row>
                  <v-col cols="12" class="col-md-2" :class="colclass">
                    <i-text-field
                      :label="itemLabel('schoolactType')"
                      v-model="item.schoolactType"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[rules.required('schoolactType', true)]"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col cols="12" class="col-md-4" :class="colclass">
                    <i-text-field
                      v-model="item.schoolactOrganization"
                      v-maxlength="'schoolact_organization'"
                      :label="itemLabel('schoolactOrganization')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('schoolactOrganization'),
                        rules.maxlength('schoolactOrganization'),
                      ]"
                      @blur="save(i)"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('schoolactSdate')"
                      useMaxCurrentDate
                      :rules="[rules.required('schoolactSdate')]"
                      v-model="item.startDate"
                      @change="save(i)"
                      :type="
                        schoolactSdateFormat === 'YYYY.MM' ? 'month' : 'date'
                      "
                    />
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('schoolactEdate')"
                      :min="item.startDate"
                      :disabled="item.isEmployed == 'Y'"
                      :rules="[rules.required('schoolactEdate')]"
                      v-model="item.endDate"
                      @change="save(i)"
                      :type="
                        schoolactEdateFormat === 'YYYY.MM' ? 'month' : 'date'
                      "
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-none d-md-block pl-3 col-md-1" v-if="!isReadonly">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>

            <template v-if="schoolActivity === 'B' || schoolActivity === 'C'">
              <v-row :class="rowclass">
                <v-col cols="12" :class="colclass">
                  <i-text-field
                    :label="itemLabel('schoolactPosition')"
                    v-model="item.schoolactPosition"
                    v-maxlength="'schoolact_position'"
                    outlined
                    dense
                    hide-details="auto"
                    @blur="save(i)"
                    :rules="[
                      rules.required('schoolactPosition'),
                      rules.maxlength('schoolactPosition'),
                    ]"
                    :readonly="isReadonly"
                  ></i-text-field>
                </v-col>
              </v-row>
            </template>
            <v-row :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-textarea
                  outlined
                  :label="itemLabel('schoolactDescription')"
                  v-model="item.schoolactDescription"
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('schoolactDescription'),
                    rules.maxlength('schoolactDescription'),
                  ]"
                  :counter="itemLength('schoolactDescription')"
                  @blur="save(i)"
                  :disabled="itemLength('schoolactDescription') == 0"
                  :readonly="isReadonly"
                ></i-textarea>
              </v-col>
            </v-row>
            <template v-if="schoolActivity === 'C'">
              <v-row :class="rowclass">
                <v-col cols="12" :class="colclass">
                  <i-text-field
                    :label="itemLabel('schoolactNote')"
                    v-model="item.schoolactNote"
                    v-maxlength="'schoolactNote'"
                    outlined
                    dense
                    hide-details="auto"
                    @blur="save(i)"
                    :rules="[
                      rules.required('schoolactNote'),
                      rules.maxlength('schoolactNote'),
                    ]"
                    :readonly="isReadonly"
                  ></i-text-field>
                </v-col>
              </v-row>
            </template>
            <v-row class="mt-2" v-if="!isReadonly">
              <v-col cols="12" class="d-md-none d-block">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
          </div>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import { mdiCalendarBlank } from '@mdi/js';
import { resumeType } from '@/const/resumeType';
import { equals } from '@/utils/util';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import { snack } from '@/plugins/dialog/api';

export default {
  mixins: [LoadingMixin],
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  components: {
    CommonDatePicker,
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.schoolact?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.schoolact?.oMaxLength ||
        this.opts.schoolact?.oMaxLength > this.schoolActivities.length
      );
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    lrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  data: () => ({
    mdiCalendarBlank,
    itemDelimeter: '#',
    itemSeq: 1,
    obj: null,
    schoolActivity: '',
    schoolActivities: [],
    schoolactSdateFormat: '',
    schoolactEdateFormat: '',
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      return label;
    },
    itemLength: function(key) {
      var length = 0;
      if (this.opts && this.opts.hasOwnProperty(key)) {
        var defaultLength = 2;
        length = this.opts[key].oLength
          ? this.opts[key].oLength
          : defaultLength;
      }
      return length;
    },
    itemArray: function(key) {
      var array = [];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        array = this.opts[key].oItems
          ? this.opts[key].oItems.split(this.itemDelimeter)
          : [];
      }
      return array;
    },
    setting() {
      //DATE VALIDATE RULE SET

      const type =
        resumeType.typeSchoolActivity[this.template.typeSchoolActivity];

      if (type) {
        const items = type;
        this.schoolActivity = Object.keys(
          resumeType.typeSchoolActivity,
        ).find(key => equals(items, resumeType.typeSchoolActivity[key]));
      }

      if (this.opts) {
        let $this = this;
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (prop.id.cvColumn === 'schoolactSdate') {
            $this.schoolactSdateFormat = prop.oFormat;
          } else if (prop.id.cvColumn === 'schoolactEdate') {
            $this.schoolactEdateFormat = prop.oFormat;
          }
        }
      }
      this.dataSetting();
      this.obj = this.defaultObj();
    },
    dataSetting: function() {
      if (
        this.info &&
        this.info.schoolActivities &&
        this.info.schoolActivities.length > 0
      ) {
        this.itemSeq = this.info.schoolActivities[0].id.seq;
        this.schoolActivities = [];

        let $this = this;
        this.info.schoolActivities.forEach(function(v) {
          var startDate = '';
          var endDate = '';

          if (v.schoolactSdate) {
            const date = [
              v.schoolactSdate.substring(0, 4),
              v.schoolactSdate.substring(4, 6),
              v.schoolactSdate.substring(6, 8),
            ];
            $this.schoolactSdateFormat === 'YYYY.MM' && date.pop();
            startDate = date.filter(v => v).join('-');
          }

          if (v.schoolactEdate) {
            const date = [
              v.schoolactEdate.substring(0, 4),
              v.schoolactEdate.substring(4, 6),
              v.schoolactEdate.substring(6, 8),
            ];
            $this.schoolactEdateFormat === 'YYYY.MM' && date.pop();
            endDate = date.filter(v => v).join('-');
          }
          let obj = {
            ...v,
            seq: v.id.seq,
            startDate,
            endDate,
          };

          $this.schoolActivities.push(obj);
          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      let obj = {
        seq: this.itemSeq++,
        schoolactOrganization: '',
        schoolactSdate: '',
        schoolactEdate: '',
        schoolactType: '',
        schoolactPosition: '',
        schoolactDescription: '',
        schoolactNote: '',
        startDate: '',
        endDate: '',
      };
      return obj;
    },
    add: function() {
      if (!this.canAdd && this.$i18n.locale == 'ko')
        return this.$showAlert(
          `${this.template.schoolactTitle} 은(는) 최대 ${this.opts.schoolact.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      else if (!this.canAdd && this.$i18n.locale == 'en')
        return this.$showAlert(
          `MaxSize of ${this.template.schoolactTitle} is ${this.opts.schoolact.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    monthdiff: function(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.schoolact &&
        this.opts.schoolact.oRequireYn &&
        this.opts.schoolact.oRequireYn == 'Y' &&
        this.schoolActivities.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    async save(i) {
      await this.$nextTick();
      var item = i === -1 ? this.obj : this.schoolActivities[i];
      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;
      const id = {
        annoId: this.$route.params.annoId,
        seq: item.seq,
      };

      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거

      const p = {
        id,
        ...Object.keys(item).reduce((a, key) => {
          /** @type {string} */
          if (key.startsWith('schoolact')) a[key] = item[key];
          return a;
        }, {}),
        schoolactSdate: item.startDate?.replace(pattern, '') || '',
        schoolactEdate: item.endDate?.replace(pattern, '') || '',
      };
      this.$emit('save', p, 'schoolActivity', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('SCHOOLACT SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
      //SAVE FORM
      if (i === -1) {
        this.schoolActivities.push(this.obj);
        this.obj = this.defaultObj();
        this.$refs.saveForm.resetValidation();
      }
    },
    delete: function(i) {
      this.showLoading();
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.schoolActivities[i].seq,
      };

      this.$emit('delete', p, 'schoolActivity', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('SCHOOLACT DELETE FAIL');
      } else {
        snack.danger(`삭제되었습니다.`);
        this.schoolActivities.splice(i, 1);
      }
      this.hideLoading();
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-career .sub-title-standard {
  position: relative;
}
.type-career .sub-title-standard .v-input__slot {
  padding-left: 100px !important;
}
.type-career .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
</style>
